import { useReadQuery } from '@apollo/client';
import { TerminalTabsQueryQuery } from '@/__generated__/graphql';
import { TerminalTab } from '@/__generated__/schema-types.ts';
import { useAuthenticatedAppLoader } from '@/routes/_app/loader';

export const useTerminalTabs = () => {
  const data = useAuthenticatedAppLoader();

  const {
    data: { terminalTabs },
  } = useReadQuery<TerminalTabsQueryQuery>(data.terminalTabsQueryRef);

  return (terminalTabs || []) as TerminalTab[];
};
